import Request, { Methods } from '@libraries/request/'
import ModelHero from '@models/hero'

export default class SameHeroes extends Request {
  constructor(options) {
    super()
    this.baseHeroId = options ? options.baseHeroId : null
  }

  get path() {
    return '/apis/same_heroes'
  }

  get method() {
    return Methods.get
  }

  decode({ data }) {
    const _data = []
    for (let key in data) {
      const item = {}
      item[key] = data[key].map((d) => new ModelHero(d))
      _data.push(item)
    }
    return this.baseHeroId ? _data.filter(d => Object.keys(d).includes(String(this.baseHeroId)))[0][this.baseHeroId] : _data
  }

  decodeError(error) {
    return { error: error }
  }
}
